import img1 from '../assets/images/1.jpeg';
import img2 from '../assets/images/2.jpeg';
import img3 from '../assets/images/3.jpeg';
import img4 from '../assets/images/4.jpeg';
import img5 from '../assets/images/5.jpeg';
import img6 from '../assets/images/6.jpeg';

export const landingSections = [
  {
    src: img1,
    alt: '아이의 경험을 기록하면 아이에게 맞는 교육이 보입니다.',
    width: 1000,
    height: 3250,
    slices: [
      { top: 0, height: 1080, anim: 'fade-up' },
      { top: 1080, height: 920, anim: 'zoom-in float' },
      { top: 2000, height: 520, anim: 'fade-up' },
      { top: 2520, height: 480, anim: 'slide-up' },
      { top: 3000, height: 250, anim: 'pulse-soft' },
    ],
  },
  {
    src: img2,
    alt: '우리 아이가 뭘 좋아하는지, 정확히 알고 계신가요?',
    width: 1000,
    height: 2700,
    slices: [
      { top: 0, height: 980, anim: 'fade-in' },
      { top: 980, height: 720, anim: 'slide-up' },
      { top: 1700, height: 520, anim: 'slide-left' },
      { top: 2220, height: 480, anim: 'slide-right' },
    ],
  },
  {
    src: img3,
    alt: '아이의 경험을 데이터로, 교육을 맞춤으로.',
    width: 1000,
    height: 4022,
    slices: [
      { top: 0, height: 680, anim: 'fade-up' },
      { top: 680, height: 1120, anim: 'slide-right' },
      { top: 1800, height: 1120, anim: 'slide-left' },
      { top: 2920, height: 1102, anim: 'zoom-in' },
    ],
  },
  {
    src: img4,
    alt: '놀면서 경험하고, 자연스럽게 나를 알아가요.',
    width: 1000,
    height: 5262,
    slices: [
      { top: 0, height: 760, anim: 'fade-up' },
      { top: 760, height: 1380, anim: 'zoom-in' },
      { top: 2140, height: 1260, anim: 'fade-in' },
      { top: 3400, height: 1862, anim: 'slide-up' },
    ],
  },
  {
    src: img5,
    alt: '한 번의 체험이 아이의 성장 기록이 됩니다.',
    width: 1000,
    height: 3721,
    slices: [
      { top: 0, height: 900, anim: 'fade-up' },
      { top: 900, height: 1480, anim: 'slide-up' },
      { top: 2380, height: 520, anim: 'fade-up' },
      { top: 2900, height: 821, anim: 'slide-left' },
    ],
  },
  {
    src: img6,
    alt: '아이로그 부스 도입 안내',
    width: 1000,
    height: 4843,
    inquiry: true,
    slices: [
      { top: 0, height: 1180, anim: 'fade-up' },
      { top: 1180, height: 420, anim: 'slide-left' },
      { top: 1600, height: 420, anim: 'fade-up' },
      { top: 2020, height: 420, anim: 'slide-right' },
      { top: 2440, height: 1220, anim: 'fade-in' },
      { top: 3660, height: 980, anim: 'zoom-in' },
      { top: 4640, height: 203, anim: 'fade-up' },
    ],
  },
];
